'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Checklists = function Checklists(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M6.70588235,16 L7.41176471,16.7058824 L4.12235294,20 L2,17.8823529 L2.70588235,17.1764706 L4.12235294,18.5882353 L6.70588235,16 Z M21,17 L21,19 L10,19 L10,17 L21,17 Z M6.70588235,10 L7.41176471,10.7058824 L4.12235294,14 L2,11.8823529 L2.70588235,11.1764706 L4.12235294,12.5882353 L6.70588235,10 Z M21,11 L21,13 L10,13 L10,11 L21,11 Z M6.70588235,4 L7.41176471,4.70588235 L4.12235294,8 L2,5.88235294 L2.70588235,5.17647059 L4.12235294,6.58823529 L6.70588235,4 Z M21,5 L21,7 L10,7 L10,5 L21,5 Z",
    id: "Combined-Shape",
    fill: "#000000"
  }));
};

var Checklists$1 = iconStyles()(Checklists);

module.exports = Checklists$1;
